import { useTriggers } from "../hooks/useTriggers";
import { Button, Card, Popover, Stack, Title } from "@introist/react-foundation/v2";
import { useState } from "react";
import { IconPickerIcon } from "../../../components/organisms";

export const WorkflowTriggers = ({ workflowId }: { workflowId: string }) => {
  const { triggers } = useTriggers({ workflowId });

  const [ref, setRef] = useState<HTMLDivElement | null>(null);
  const [open, setOpen] = useState(false);

  if (!triggers || triggers.length === 0) {
    return null;
  }

  return (
    <div ref={setRef}>
      <Button startIcon="trigger" variant="outlined" size="small" onClick={() => setOpen(!open)}>
        {triggers.length}
      </Button>
      <Popover
        open={open}
        closeOnContentClick={false}
        onClose={() => setOpen(false)}
        placement="bottom-end"
        referenceElement={ref}
      >
        <Card style={{ width: "400px" }}>
          <Stack vertical>
            <Title>This workflow is triggered by</Title>
            {triggers.map(trigger => (
              <Card
                key={trigger.id}
                onClick={() =>
                  window.open(`/triggers/${trigger.id}`, "_blank", "noopener,noreferrer")
                }
                style={{ cursor: "pointer" }}
              >
                <Stack>
                  <IconPickerIcon fallbackIcon="trigger" />
                  <Title variant="bold" style={{ lineBreak: "auto" }}>
                    {trigger.name}
                  </Title>
                </Stack>
              </Card>
            ))}
          </Stack>
        </Card>
      </Popover>
    </div>
  );
};
